var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tiptap-vuetify',{attrs:{"value":_vm.value,"placeholder":_vm.field.label,"extensions":_vm.extensions,"color":"#005c7b"},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }